export class ResponseDTO<T> {
    public static STATUS_SUCCESS = 'success';
    public static STATUS_ERROR = 'error';

    status: string;
    message: string;
    result: T;
    instanceId: string;
}
